import { AssetClass } from '@/entities/assets'

import { TRANSACTION_TYPE } from '@/entities/transactions/utils/const'

import { WizardValues } from '../utils/types'
import { createHolding, createMarks, ensureOwnerAccount, ensureTagIds } from '../utils/create'

/**
 * One vehicle, held in the account the ownership step named.
 *
 * The type comes off the values rather than from a constant here: the flow
 * fixes it in its definition, and reading it back is what keeps the summary's
 * claim and the created record the same fact.
 */
export const create = async (values: WizardValues): Promise<AssetClass[]> => {
  const tagIds = await ensureTagIds(values.tags)
  const accountId = await ensureOwnerAccount(values)

  const vehicle = await createHolding({
    accountId,
    transactionType: TRANSACTION_TYPE.ADD_POSITION,
    name: values.assetName,
    type: values.assetType,
    currency: values.currency,
    description: values.description,
    amount: values.amount,
    date: values.date,
    tagIds,
  })

  /*
   * After the holding, because a price needs the asset it is a price of. An
   * empty list is the normal case — the valuation step is optional.
   */
  await createMarks(vehicle.id, values.prices)

  return [vehicle]
}
